/*
 *
 * ImportDivisionsContainer actions
 *
 */

import {
  SAVE_TEMPLATE_WATCHER,
  SAVE_TEMPLATE_SUCCESS,
  SAVE_TEMPLATE_FAILED,
  SAVE_TEMPLATE_PROGRESS,
  CLOSE_IMPORT,
  UPLOAD_TEMPLATE_W,
  GET_DIVISIONS_SUMMARY_WATCHER,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
} from "./constants"

export function saveTemplateWatcher(payload) {
  return {
    type: SAVE_TEMPLATE_WATCHER,
    payload,
  }
}

export function saveTemplateSuccess(payload) {
  return {
    type: SAVE_TEMPLATE_SUCCESS,
    payload,
  }
}

export function saveTemplateFailed() {
  return { type: SAVE_TEMPLATE_FAILED }
}

export function saveTemplateProgress(payload) {
  return {
    type: SAVE_TEMPLATE_PROGRESS,
    payload,
  }
}

export function closeImport() {
  return { type: CLOSE_IMPORT }
}

// export function uploadTemplate(payload) {
//   return {
//     type: UPLOAD_TEMPLATE_W,
//     payload
//   }
// }

export function getDivisionsSummaryWatcher(payload) {
  return {
    type: GET_DIVISIONS_SUMMARY_WATCHER,
    payload,
  }
}

// UPLOAD TEMPLATE
export function uploadTemplate(payload) {
  return {
    type: UPLOAD_TEMPLATE_WATCHER,
    payload,
  }
}

export function uploadTemplateSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_SUCCESS,
    payload,
  }
}

export function uploadTemplateFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_FAILED,
    payload,
  }
}
